import { CheckCircle, Search } from "lucide-react";
import {
  handleFetchVehicles,
  handleUpdateUnprogrammed,
} from "../../../api/vehicles";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Input, Popover, message } from "antd";
import { useState } from "react";

export default function Completed() {
  const queryClient = useQueryClient();
  const [keyword, setKeyword] = useState<string>("");
  const { data: vehicles } = useQuery({
    queryKey: ["vehicles", "programmed", keyword],
    queryFn: () => handleFetchVehicles({ keyword, state: "programmed" }),
  });

  const { mutate } = useMutation({
    mutationFn: handleUpdateUnprogrammed,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicles", "programmed"] });
      queryClient.invalidateQueries({ queryKey: ["vehicles", "unprogrammed"] });
      message.success("Vehicle marked as unprogrammed");
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });
  const handleUnprogrammed = (vehicle: any) => {
    mutate({ _id: vehicle?._id });
  };

  const content = (
    <div>
      <p>Are you sure you want to mark this vehicle as unprogrammed?</p>
    </div>
  );

  return (
    <div className="">
      <div className="text-center text-gray-500 border-x border-t border-b-4 border-green-300 p-2 bg-green-200">
        <span className="font-bold">{vehicles?.total}</span> Vehicles Programmed
      </div>
      <div className="p-1 bg-green-100 border border-gray-200">
        <Input
          placeholder="Search Reg Number or VIN Number"
          value={keyword}
          prefix={<Search size={12} className="text-gray-500" />}
          onChange={(e: any) => setKeyword(e.target.value)}
          allowClear
          onPressEnter={(e: any) => setKeyword(e.target.value)}
        />
      </div>
      {vehicles?.records?.map((vehicle: any) => (
        <div
          key={vehicle._id}
          className="flex items-center justify-between border px-1 text-xxs"
        >
          <div>{vehicle.regNumber}</div>
          <div className="flex items-center gap-x-2">
            <div>{vehicle.vinNumber}</div>
            <Popover
              placement="top"
              title={
                <div className="flex items-center gap-x-1">
                  Mark as Unprogrammed :
                  <span className="text-gray-500 text-xs font-bold">
                    ({vehicle.regNumber})
                  </span>
                </div>
              }
              content={content}
            >
              <button
                onClick={() => handleUnprogrammed(vehicle)}
                className=" text-green-500 flex items-center gap-x-1 hover:text-green-600"
              >
                <CheckCircle size={12} /> Programmed
              </button>
            </Popover>
          </div>
        </div>
      ))}
    </div>
  );
}
